import { gql } from '@eti/schema-types';

export const brandedFaresFragment = gql(/* GraphQL */ `
  fragment BrandedFares on BrandedFare {
    checkedBaggageSummary {
      tripSummaries {
        baggageDetails {
          pieces
          weight
          weightUnit
        }
        baggageStatus
      }
    }
    cabinBaggageTripSummary {
      cabinBaggageTravelerDetails {
        cabinBaggageDetails {
          pieces
          weight
          weightUnit
        }
        cabinBaggageStatus
      }
    }
    features {
      availability
      code
      group
      name
    }
    id
    name
    selectionKey
    travelerPrices {
      id
      price {
        price {
          value
        }
      }
      travelerId
    }
    travelers {
      age
      ageType
      id
    }
  }
`);

export const SELECT_TRIP_WITH_DATA = gql(/* GraphQL */ `
  mutation SelectTripWithDataOnResultPage(
    $selectionKey: String!
    $extraProductSelection: [ID]
    $bundleProductSelection: [BundleSelectionInput]
    $searchPath: String
    $excludedExtraProductIds: [ID]
  ) {
    selectTrip(
      selectionKey: $selectionKey
      extraProductSelection: $extraProductSelection
      bundleProductSelection: $bundleProductSelection
      searchPath: $searchPath
    ) {
      success
      selectedTrip {
        availableAncillaryBundles {
          id
        }
        id
        isVI
        tripId
        selectionKey
        brandedFares {
          ...BrandedFares
        }
        availableExtraProducts(excludedExtraProducts: $excludedExtraProductIds) {
          ...AvailableExtraProducts
        }
        includedExtraProducts {
          id
          texts {
            name
            productSummaryAlternativeName
            readMoreText
            receiptText
            salesAbstract
          }
        }
        includedCabinBaggage {
          includedPersonalItem
          size3d {
            height
            length
            width
          }
          ...IncludedCabinBaggage
        }
        includedCheckedBaggage {
          ...IncludedCheckedBaggage
        }
        bounds {
          boundId: id
          includedCheckedBaggage {
            ...IncludedCheckedBaggage
          }
          includedCabinBaggage {
            ...IncludedCabinBaggage
          }
          segments {
            ... on TripSegment {
              __typename
              segmentId: id
              aircraftType
              arrivedAt
              includedCheckedBaggage {
                ...IncludedCheckedBaggage
              }
              includedCabinBaggage {
                ...IncludedCabinBaggage
              }
              brandedFareInformation {
                name
              }
              cabinClassName
              departuredAt
              destination {
                code
                name
                cityCode
                cityName
              }
              duration
              equipmentCode
              flightNumber
              marketingCarrier {
                code
                name
              }
              numberOfTechnicalStops
              technicalStops {
                arrivalAt
                departureAt
                duration
                location {
                  code
                  name
                  cityName
                  cityCode
                }
              }
              operatingCarrier {
                code
                name
              }
              operatingInformation
              origin {
                code
                name
                cityCode
                cityName
              }
              segmentDetails {
                paxType
                numberOfSeatsLeft
              }
            }
            ... on EventSegment {
              __typename
              types
              duration
              segmentId: id
            }
          }
        }
        tripTravelers: travelers {
          id
          ageType
        }
        travelerPrices {
          ...TravelerPrices
        }
        travelerPricesWithoutPaymentDiscounts {
          price {
            markup {
              value
            }
            price {
              value
              currency {
                code
              }
            }
            vat {
              value
            }
          }
          taxesAndFees {
            category
            taxes {
              code
              title
              amount {
                value
              }
            }
          }
          travelerId
        }
        tripCharacteristics
        paymentMethodPrices {
          ...PaymentMethodPrices
        }
        tripCharacteristics
        systems
        voucherAmount {
          value
        }
        shareableUrl
        type
      }
    }
  }
`);

export const SELECT_TRIP = gql(/* GraphQL */ `
  mutation SelectTripOnResultPage(
    $selectionKey: String!
    $extraProductSelection: [ID]
    $bundleProductSelection: [BundleSelectionInput]
    $searchPath: String
  ) {
    selectTrip(
      selectionKey: $selectionKey
      extraProductSelection: $extraProductSelection
      bundleProductSelection: $bundleProductSelection
      searchPath: $searchPath
    ) {
      success
    }
  }
`);
